import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export default class RecycleFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            end_date: null,
        };
        console.log(this.props);
    }

    downloadReport = () => {
        let formData = new FormData();
        formData.append('date', moment(this.state.date).format('YYYY/MM/DD'));
        formData.append('end_date', moment(this.state.end_date).format('YYYY/MM/DD'));
        axios.post(this.props.reportRoute, formData);
    };

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <label className="text-uppercase">Start Month</label>
                        <DatePicker
                            selected={this.state.date}
                            onChange={(date) => this.setState({ date: date })}
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Select month"
                        />
                    </div>
                    <div className="col-md-4 form-group">
                        <label className="text-uppercase">End Month (inclusive)</label>
                        <DatePicker
                            selected={this.state.end_date}
                            onChange={(date) => this.setState({ end_date: date })}
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Select month"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <a
                            href={
                                this.props.reportRoute +
                                '?date=' +
                                moment(this.state.date).format('YYYY/MM/DD') +
                                (this.state.end_date
                                    ? '&end_date=' + moment(this.state.end_date).format('YYYY/MM/DD')
                                    : '')
                            }
                            className="btn btn-cw-primary"
                        >
                            Download Report
                        </a>
                    </div>
                </div>
            </>
        );
    }
}

if (document.getElementById('recycle-filter')) {
    let element = document.getElementById('recycle-filter');

    ReactDOM.render(<RecycleFilter reportRoute={element.dataset.report_route} />, element);
}
